<div class="main-content-container">
  <div class="container-title">
    <div class="d-flex align-items-center">
      <div class="pl-2 pr-2">
        <a class="d-inline-flex" href="javascript:void(0)" (click)="previous()">
          <img _ngcontent-lww-c11="" src="assets/images/grid-back.png">
        </a>
      </div>
      <h3 class="mb-0 text-capitalize">review Order</h3>
    </div>
  </div>
  <div class="main-container-body">
    @if (bannerJson) {
      <app-resource-banner [bannerJson]="bannerJson"></app-resource-banner>
    }
    <div class="card">
      <div class="card-body">
        <div class="col-12">
          @for (r of keys; track r) {
            <div class="col-6 float-left">
              <label><b>{{r}} : </b></label>
              <p>{{data[r]}}</p>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="text-align-center" align="center">
      <button class="primary-btn" (click)="getPaymentDetail()">Payment Method</button>
    </div>
  </div>
</div>
<div dhs-modal></div>